import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { PATH_INFO } from "./pages/utils/helper";
import { Login } from "./pages/Login/Login";
import { PageLayout } from "./pages/PageLayout";
import { Home } from "./pages/home";
import { ProtectedRoute } from "./pages/ProtectedRoute";
import { AuthProvider } from "./context/authContext";
import { SamplesProvider } from "./context/samplesContext";
import { PastMeasurements } from "./pages/PastMeasurements";
import { UserProvider } from "./context/userContext";
import { Specification } from "./pages/Specification";
import { TableProvider } from "./context/tableContext";
import { SpecificationDownload } from "./pages/Specification-download";
import { QrSearch } from "./pages/Qr-search";
import { EcPhoto } from "./pages/Ec-photo";
import { BackgroundTile } from "./components/Background-tile";

const router = createBrowserRouter([
  {
    path: PATH_INFO.LOGIN.PATH,
    element: (
      <AuthProvider>
        <Login />
      </AuthProvider>
    )
  },
  {
    element: (
      <AuthProvider>
        <SamplesProvider>
          <UserProvider>
            <ProtectedRoute>
              <TableProvider>
                <PageLayout />
              </TableProvider>
            </ProtectedRoute>
          </UserProvider>
        </SamplesProvider>
      </AuthProvider>
    ),
    children: [
      {
        path: PATH_INFO.HOME.PATH,
        element: (
          <Home />
        ),
        children: [
          {
            path: `${PATH_INFO.HOME.PATH}/samples/:sampleId`,
            element: <Home />
          }
        ]
      },
      {
        path: PATH_INFO.PAST_MEASUREMENTS.PATH,
        element: (
          <BackgroundTile responsiveBreakpoint="laptop-sm">
            <PastMeasurements />
          </BackgroundTile>
        )
      },
      {
        path: PATH_INFO.SPECIFICATION_INPORT.PATH,
        element: <Specification />
      },
      {
        path: PATH_INFO.SPECIFICATION_DOWNLOAD.PATH,
        element: (
          <BackgroundTile responsiveBreakpoint="desktop-md">
            <SpecificationDownload />
          </BackgroundTile>
        )
      },
      {
        path: PATH_INFO.QR_SEARCH.PATH,
        element: (
          <BackgroundTile responsiveBreakpoint="desktop-sm">
            <QrSearch />
          </BackgroundTile>
        )
      },
      {
        path: PATH_INFO.EC_PHOTO.PATH,
        element: (
          <BackgroundTile responsiveBreakpoint="laptop-sm">
            <EcPhoto />
          </BackgroundTile>
        )
      }
    ]
  }
])

const App = () => {
  return <RouterProvider router={router} />
};

export default App;
